// extracted by mini-css-extract-plugin
module.exports = {"title":"ccfda6eb9f--title--IPOAo"};